webpackJsonp([35783957827783],{

/***/ 325:
/***/ (function(module, exports) {

	'use strict';
	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp(token, 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');
	
	function decodeComponents(components, split) {
		try {
			// Try to decode the entire string first
			return decodeURIComponent(components.join(''));
		} catch (err) {
			// Do nothing
		}
	
		if (components.length === 1) {
			return components;
		}
	
		split = split || 1;
	
		// Split the array in 2 parts
		var left = components.slice(0, split);
		var right = components.slice(split);
	
		return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}
	
	function decode(input) {
		try {
			return decodeURIComponent(input);
		} catch (err) {
			var tokens = input.match(singleMatcher);
	
			for (var i = 1; i < tokens.length; i++) {
				input = decodeComponents(tokens, i).join('');
	
				tokens = input.match(singleMatcher);
			}
	
			return input;
		}
	}
	
	function customDecodeURIComponent(input) {
		// Keep track of all the replacements and prefill the map with the `BOM`
		var replaceMap = {
			'%FE%FF': '\uFFFD\uFFFD',
			'%FF%FE': '\uFFFD\uFFFD'
		};
	
		var match = multiMatcher.exec(input);
		while (match) {
			try {
				// Decode as big chunks as possible
				replaceMap[match[0]] = decodeURIComponent(match[0]);
			} catch (err) {
				var result = decode(match[0]);
	
				if (result !== match[0]) {
					replaceMap[match[0]] = result;
				}
			}
	
			match = multiMatcher.exec(input);
		}
	
		// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
		replaceMap['%C2'] = '\uFFFD';
	
		var entries = Object.keys(replaceMap);
	
		for (var i = 0; i < entries.length; i++) {
			// Replace all decoded components
			var key = entries[i];
			input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
		}
	
		return input;
	}
	
	module.exports = function (encodedURI) {
		if (typeof encodedURI !== 'string') {
			throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
		}
	
		try {
			encodedURI = encodedURI.replace(/\+/g, ' ');
	
			// Try the built in decoder first
			return decodeURIComponent(encodedURI);
		} catch (err) {
			// Fallback to a more advanced decoder
			return customDecodeURIComponent(encodedURI);
		}
	};


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(547);
	var objectAssign = __webpack_require__(8);
	var decodeComponent = __webpack_require__(325);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	function extract(str) {
		var queryStart = str.indexOf('?');
		if (queryStart === -1) {
			return '';
		}
		return str.slice(queryStart + 1);
	}
	
	function parse(str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^[?#&]/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeComponent(val);
	
			formatter(decodeComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	}
	
	exports.extract = extract;
	exports.parse = parse;
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		if (opts.sort === false) {
			opts.sort = function () {};
		}
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};
	
	exports.parseUrl = function (str, opts) {
		return {
			url: str.split('?')[0] || '',
			query: parse(extract(str), opts)
		};
	};


/***/ }),

/***/ 547:
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n'], ['\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 100%;\n\tmargin: 8vh 0vw 5vh 0vw;\n\ta {\n\t\ttext-decoration: none;\n\t\tcolor: black;\n\t}\n\n\tspan {\n\t\tcursor: pointer;\n\t}\n\n\t@media (max-width: 480px){\n\t\tflex-wrap: wrap;\n\t\tmargin: 5vh 0 3.5vh 0;\n\t\tmax-width: 14em;\n\t}\n'], ['\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 100%;\n\tmargin: 8vh 0vw 5vh 0vw;\n\ta {\n\t\ttext-decoration: none;\n\t\tcolor: black;\n\t}\n\n\tspan {\n\t\tcursor: pointer;\n\t}\n\n\t@media (max-width: 480px){\n\t\tflex-wrap: wrap;\n\t\tmargin: 5vh 0 3.5vh 0;\n\t\tmax-width: 14em;\n\t}\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n\tfont-family: Roboto;\n\tfont-size: 22px;\n\tfont-weight: 300;\n\tmargin: 0 1.5vw 0 1.5vw;\n\n\t&:hover{\n\t\tcolor: darkgrey;\n\t}\n\n\t@media (max-width: 480px){\n\t\tfont-size: 17px;\n\t\tmargin: 0 2vw 1.5vh 2vw;\n\t}\n'], ['\n\tfont-family: Roboto;\n\tfont-size: 22px;\n\tfont-weight: 300;\n\tmargin: 0 1.5vw 0 1.5vw;\n\n\t&:hover{\n\t\tcolor: darkgrey;\n\t}\n\n\t@media (max-width: 480px){\n\t\tfont-size: 17px;\n\t\tmargin: 0 2vw 1.5vh 2vw;\n\t}\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-content: flex-start;\n\tjustify-content: center;\n\tmargin:  0 5vw 5vh 5vw;\n\tmax-width: 1500px;\n    width: 90%;\n'], ['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-content: flex-start;\n\tjustify-content: center;\n\tmargin:  0 5vw 5vh 5vw;\n\tmax-width: 1500px;\n    width: 90%;\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n\ttext-decoration: none;\n\tflex-basis: 420px;\n    margin: 10px;\n    margin-bottom: ', '\n\t\n\t@media (max-width: 980px){\n\t\tflex-basis: 42%;\n\t}\n'], ['\n\ttext-decoration: none;\n\tflex-basis: 420px;\n    margin: 10px;\n    margin-bottom: ', '\n\t\n\t@media (max-width: 980px){\n\t\tflex-basis: 42%;\n\t}\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tposition: relative;\n\tflex-basis: 33%;\n\n\t&:hover > div{\n\t\topacity: 0.8;\n\t\tcursor: pointer;\n\t}\n\n\t&:hover > p {\n\t\topacity: 1;\n\t}\n\n\timg {\n\t\tmargin: 0;\n\t}\n'], ['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tposition: relative;\n\tflex-basis: 33%;\n\n\t&:hover > div{\n\t\topacity: 0.8;\n\t\tcursor: pointer;\n\t}\n\n\t&:hover > p {\n\t\topacity: 1;\n\t}\n\n\timg {\n\t\tmargin: 0;\n\t}\n']),
	    _templateObject7 = _taggedTemplateLiteralLoose(['\n\tbackground-color: ', ';\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\topacity: 0;\n\n\t@media (max-width: 480px){\n\t\theight: 86.5%;\n\t}\n\n'], ['\n\tbackground-color: ', ';\n\tposition: absolute;\n\twidth: 100%;\n\theight: 100%;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\topacity: 0;\n\n\t@media (max-width: 480px){\n\t\theight: 86.5%;\n\t}\n\n']),
	    _templateObject8 = _taggedTemplateLiteralLoose(['\n\tfont-size: 30px;\n\tfont-family: Roboto;\n\tfont-weight: 300;\n\ttext-align: center;\n\tcolor: ', ';;\n\twidth: 100%;\n\tposition: ', ';\n\topacity: 0;\n\tcursor: pointer;\n\ttop: ', ';\n  \tleft: ', ';\n  \ttransform: ', ';\n\n  \t', '\n\n\t@media (max-width: 480px){\n\t\tfont-size: 16px;\n\t}\n'], ['\n\tfont-size: 30px;\n\tfont-family: Roboto;\n\tfont-weight: 300;\n\ttext-align: center;\n\tcolor: ', ';;\n\twidth: 100%;\n\tposition: ', ';\n\topacity: 0;\n\tcursor: pointer;\n\ttop: ', ';\n  \tleft: ', ';\n  \ttransform: ', ';\n\n  \t', '\n\n\t@media (max-width: 480px){\n\t\tfont-size: 16px;\n\t}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Picture = __webpack_require__(81);
	
	var _Picture2 = _interopRequireDefault(_Picture);
	
	var _queryString = __webpack_require__(445);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _coverImages = __webpack_require__(219);
	
	var _coverImages2 = _interopRequireDefault(_coverImages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Portfolio = _styledComponents2.default.div(_templateObject);
	
	var PortfolioCategory = _styledComponents2.default.div(_templateObject2);
	
	var PortfolioCategories = _styledComponents2.default.p(_templateObject3);
	
	var Projects = _styledComponents2.default.div(_templateObject4);
	
	var ProjectItem = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject5, function (props) {
		return props.isMobile ? '0px' : '10px';
	});
	
	var PortfolioImage = _styledComponents2.default.div(_templateObject6);
	
	var Overlay = _styledComponents2.default.div(_templateObject7, function (props) {
		return props.overlay;
	});
	// @media (max-width: 480px){
	// 	display: none;
	// }
	
	var OverlayText = _styledComponents2.default.p(_templateObject8, function (props) {
		return props.isMobile ? 'black' : 'white';
	}, function (props) {
		return props.isMobile ? 'static' : 'absolute';
	}, function (props) {
		return props.isMobile ? 'auto' : '50%';
	}, function (props) {
		return props.isMobile ? 'auto' : '50%';
	}, function (props) {
		return props.isMobile ? 'initial' : 'translate(-50%, -50%)';
	}, function (props) {
		return props.isMobile ? '\n\tfont-size: 1em;\n\topacity: 1;\n\ttop: initial;\n\tbottom: -36px;\n\tmargin: 0;\n' : '';
	});
	// <span onClick={ () => navigateTo('/?category=konzept')}><PortfolioCategories>Konzept</PortfolioCategories></span>
	// <span onClick={ () => navigateTo('/?category=report')}><PortfolioCategories>Reportage</PortfolioCategories></span>
	
	var isCategory = function isCategory(_ref) {
		var image = _ref.image,
		    category = _ref.category;
		return image.tag === category;
	};
	
	var PortfolioPage = function (_React$Component) {
		_inherits(PortfolioPage, _React$Component);
	
		function PortfolioPage(props) {
			_classCallCheck(this, PortfolioPage);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.state = { isMobile: false };
			return _this;
		}
	
		PortfolioPage.prototype.componentDidMount = function componentDidMount() {
			this.setState({
				isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
			});
		};
	
		PortfolioPage.prototype.render = function render() {
			var _this2 = this;
	
			var isMobile = this.state.isMobile;
	
			return _react2.default.createElement(
				Portfolio,
				{ id: 'portfolio' },
				_react2.default.createElement(
					PortfolioCategory,
					null,
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: '/?category=konzept' },
						_react2.default.createElement(
							PortfolioCategories,
							null,
							'Konzept'
						)
					),
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: '/?category=report' },
						_react2.default.createElement(
							PortfolioCategories,
							null,
							'Reportage'
						)
					),
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: '/portrait' },
						_react2.default.createElement(
							PortfolioCategories,
							null,
							'Portrait'
						)
					),
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: '/collage' },
						_react2.default.createElement(
							PortfolioCategories,
							null,
							'Digital Collage'
						)
					)
				),
				_react2.default.createElement(
					Projects,
					null,
					_coverImages2.default.filter(function (image) {
						var category = _queryString2.default.parse(_this2.props.location.search).category;
						return category ? isCategory({ image: image, category: category }) : true;
					}).map(function (coverImage) {
						return _react2.default.createElement(
							ProjectItem,
							{ key: coverImage.image, to: './projects/' + coverImage.link, isMobile: isMobile },
							_react2.default.createElement(
								PortfolioImage,
								null,
								_react2.default.createElement(_Picture2.default, { imagecode: coverImage.image, size: 'cover' }),
								_react2.default.createElement(Overlay, { overlay: coverImage.color }),
								_react2.default.createElement(
									OverlayText,
									{ isMobile: isMobile },
									coverImage.text
								)
							)
						);
					})
				)
			);
		};
	
		return PortfolioPage;
	}(_react2.default.Component);
	
	exports.default = PortfolioPage;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var coverImages = [{
		image: 'Parallelität/hecke',
		color: 'rgba(50, 105, 21, 0.7)',
		text: 'Parallelität',
		tag: 'konzept',
		link: 'flat'
	}, {
		image: 'Stockholm/stockholm',
		color: 'Firebrick',
		text: 'Stockholm',
		tag: 'report',
		link: 'stockholm'
	}, {
		image: 'Routine/Routine',
		color: 'rgba(255, 255, 255, 0.3)',
		text: 'Routine des Lebens',
		tag: 'konzept',
		link: 'routine'
	}, {
		image: 'AnalogAlphabet/alphabet_1',
		color: 'saddlebrown',
		text: 'Analog Alphabet',
		tag: 'konzept',
		link: 'alphabet'
	}, {
		image: 'Bologna/bologna',
		color: 'Tomato',
		text: 'Bologna',
		tag: 'report',
		link: 'bologna'
	}, {
		image: 'Stadthimmel/city',
		color: 'Steelblue',
		text: 'Stadthimmel',
		tag: 'konzept',
		link: 'citysky'
	}, {
		image: 'Bilbao/bilbao',
		color: '#E897BC',
		text: 'Bilbao',
		tag: 'report',
		link: 'bilbao'
	}, {
		image: 'Berlin/berlin',
		color: '#3BAB95',
		text: 'Berlin',
		tag: 'report',
		link: 'berlin'
	}, {
		image: 'Schreibtherapie/past',
		color: 'rgba(0, 0, 0, 0.5)',
		text: 'Schreibtherapie',
		tag: 'konzept',
		link: 'past'
	}, {
		image: 'Amsterdam/amsterdam',
		color: '#FFBD20',
		text: 'Amsterdam',
		tag: 'report',
		link: 'amsterdam'
	}, {
		image: 'Nachbarschaft/neighbour',
		color: 'rosybrown',
		text: 'Nachbarschaft',
		tag: 'konzept',
		link: 'neighbour'
	}, {
		image: 'Barcelona/barcelona',
		color: 'seagreen',
		text: 'Barcelona',
		tag: 'report',
		link: 'barcelona'
	}, {
		image: 'White/white',
		color: 'rgba(0, 0, 0, 0.4)',
		text: 'Weißes Tuch',
		tag: 'konzept',
		link: 'white'
	}, {
		image: 'Zingst/zingst',
		color: 'thistle',
		text: 'Zingst',
		tag: 'report',
		link: 'zingst'
	}, {
		image: 'Schulportrait/school',
		color: '#424A9D',
		text: 'Schulportrait',
		tag: 'konzept',
		link: 'school'
	}, {
		image: 'Palma/palma',
		color: 'steelblue',
		text: 'Palma de Mallorca',
		tag: 'report',
		link: 'palma'
	}, {
		image: 'Kopenhagen/copenhagen',
		color: 'brown',
		text: 'Kopenhagen',
		tag: 'report',
		link: 'copenhagen'
	}];
	
	exports.default = coverImages;
	
	//},{
	//image: 'PaperPurse/paperpurse',
	//color: '#F62217',
	//text: 'Paper Purse',
	//tag: 'konzept',
	//link: 'paper'
	//},{
	//image: 'Lost In The Sky/sky',
	//color: '#1F3A69',
	//text: 'Lost In The Sky',
	//tag: 'konzept',
	//link: 'sky'
	//,{
	//	image: 'Malmö/malmoe',
	//	color: '#244C9D',
	//	text: 'Malmö',
	//	tag: 'report',
	//	link: 'malmoe'
	//},{
	//	image: 'GönnDir/goenndir_9',
	//	color: 'darksalmon',
	//	text: 'Gönn Dir',
	//	tag: 'konzept',
	//	link: 'goenndir'
	//}
	//,{
	//	image: 'Farbharmonie/color',
	//	color: '#83C778',
	//	text: 'Farbharmonie',
	//	tag: 'konzept',
	//	link: 'color'
	//}
	
	module.exports = exports['default'];

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n\twidth: 100%;\n\theight: 100vh;\n\tbackground-image: url("https://res.cloudinary.com/katjakrug/image/upload/v1535890059/Back_2.jpg");\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tz-index: 0;\n\tposition: relative;\n'], ['\n\twidth: 100%;\n\theight: 100vh;\n\tbackground-image: url("https://res.cloudinary.com/katjakrug/image/upload/v1535890059/Back_2.jpg");\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tz-index: 0;\n\tposition: relative;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n\tpadding-top: 40vh;\n\ttext-align: center;\n\n\t@media (max-width: 620px){\n\t\tpadding-top: 25vh;\n\t}\n'], ['\n\tpadding-top: 40vh;\n\ttext-align: center;\n\n\t@media (max-width: 620px){\n\t\tpadding-top: 25vh;\n\t}\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n\tfont-weight: 500;\n\ttext-rendering: optimizeLegibility;\n\tfont-size: 70px;\n\tcolor: white;\n\tdisplay: inline-block;\n\n\t@media (max-width: 620px){\n\t\tfont-size: 48px;\n\t}\n'], ['\n\tfont-weight: 500;\n\ttext-rendering: optimizeLegibility;\n\tfont-size: 70px;\n\tcolor: white;\n\tdisplay: inline-block;\n\n\t@media (max-width: 620px){\n\t\tfont-size: 48px;\n\t}\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n\tfont-size: 30px;\n\tfont-weight: 300;\n\tcolor: white;\n\tmargin-top: -1vh;\n\tmargin-bottom: 3vh;\n\n\t@media (max-width: 620px){\n\t\tfont-size: 22px;\n\t\tmargin-bottom: 5vh;\n\t}\n'], ['\n\tfont-size: 30px;\n\tfont-weight: 300;\n\tcolor: white;\n\tmargin-top: -1vh;\n\tmargin-bottom: 3vh;\n\n\t@media (max-width: 620px){\n\t\tfont-size: 22px;\n\t\tmargin-bottom: 5vh;\n\t}\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n\twidth: 250px;\n\theight: 55px;\n\tmargin: auto;\n\tborder-style: solid;\n\tborder-width: 0.5px;\n\tcolor: white;\n\tdisplay: flex;\n    justify-content: center;\n    align-items: center;\n\ttext-decoration: none;\n\tfont-weight: 300;\n\n\t&:hover {\n\t\tborder-width: 3px;\n\t}\n\n\t@media (max-width: 620px){\n\t\twidth: 200px;\n\t\theight: 45px;\t\n\t\tmargin-top: -1vh;\n\t}\n'], ['\n\twidth: 250px;\n\theight: 55px;\n\tmargin: auto;\n\tborder-style: solid;\n\tborder-width: 0.5px;\n\tcolor: white;\n\tdisplay: flex;\n    justify-content: center;\n    align-items: center;\n\ttext-decoration: none;\n\tfont-weight: 300;\n\n\t&:hover {\n\t\tborder-width: 3px;\n\t}\n\n\t@media (max-width: 620px){\n\t\twidth: 200px;\n\t\theight: 45px;\t\n\t\tmargin-top: -1vh;\n\t}\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _PortfolioPage = __webpack_require__(217);
	
	var _PortfolioPage2 = _interopRequireDefault(_PortfolioPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Home = _styledComponents2.default.div(_templateObject);
	
	var HomeText = _styledComponents2.default.div(_templateObject2);
	
	var Title = _styledComponents2.default.h1(_templateObject3);
	
	var Name = _styledComponents2.default.p(_templateObject4);
	
	var ScrollLink = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject5);
	
	var HomePage = function (_React$Component) {
		_inherits(HomePage, _React$Component);
	
		function HomePage() {
			_classCallCheck(this, HomePage);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		HomePage.prototype.render = function render() {
			var location = this.props.history.location;
	
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_PortfolioPage2.default, { location: location })
			);
		};
	
		return HomePage;
	}(_react2.default.Component);
	
	exports.default = HomePage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-ece8c45aadada789d23e.js